import { Layout } from "components2";
import {
    CommonButton2, CommonButtonSecondary
} from "components2/CommonUI";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { clear, updateState } from "redux/o2Appointment";
import {
    AppointmentDetail,
    CustomerDetail,
    EnquiryDetail,
    TransactionDetail
} from "./o2AppointmentReviewComponents";
import { Modal } from "react-bootstrap";
import { O2APPOINTMENT_ENTRY, O2DELETED, O2FORM } from "constants/route";
import { cancelAppointment, getAppointment } from "services/api-service2";

import { useAdobeDigitalData, useWogaa } from "hooks";
// import { getExistingAppt } from "services/api-service2";

// This page will load appointment info by itself.
// only need nricFin | passport
export default function O2AppointmentInfo() {
  const [agree, setAgree] = useState(false);
  const navigate = useNavigate();
  const {
    nricFin,
    passport,
    hasApptNricFin,
    hasApptPassport,
    otpToken,
    apptDateTime
  } = useSelector((state) => state.o2Appointment);
  useAdobeDigitalData({name: "APPOINTMENT_INFO", path:"/appointment-info"});

  const { nric } = useSelector((state) => state.appointment);
  const dispatch = useDispatch();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);
  const { name: fullName, isLogin } = useSelector((state) => state.signPassIdentify);
  const { startCancel: wogaaStartCancel, endComplete } = useWogaa();

  const location = useLocation();

  useEffect(() => {
    // if(nric === "S6475152B" || hasApptNricFin === "S6475152B") {
    //   dispatch(updateState({
    //     ack : true, 
    //     apptDateId : 1, 
    //     apptDateTime : moment().toDate(),
    //     apptTimeRangeEndTime : "1000",
    //     apptTimeRangeId : 1,
    //     apptTimeRangeStartTime : "0900",
    //     apptTimeslotId : 1, 
    //     apptType : "VISIT", 
    //     apptTypeId : 4, 
    //     companionIdType : null, 
    //     companionNricFin : null, 
    //     companionPassport : null, 
    //     email : null, 
    //     emailFromUCD : null, 
    //     emailUseUCD : null, 
    //     haveCompanion : false, 
    //     idType : "NRIC_FIN", 
    //     language : "EN", 
    //     locationDesc : "Tempines Service Centre", 
    //     locationId : 2, 
    //     mid : 1, 
    //     midDesc : "Main Service 1", 
    //     mobileNumber : null, 
    //     mobileNumberFromUCD : "92207844", 
    //     mobileUseUCD : true, 
    //     modeOfContact : "PHONE", 
    //     nricFin : "S6475152B", 
    //     otp : null, otpToken : null, 
    //     passport : null, 
    //     sid : 1, 
    //     sidDesc : "Sub Service 1.1",
    //     hasApptNricFin,
    //     otpToken: "xxx",
    //   }));
    // } else if(hasApptPassport === "K123456") {
    //   dispatch(updateState({
    //     ack : true, 
    //     apptDateId : 1, 
    //     apptDateTime : moment().toDate(),
    //     apptTimeRangeEndTime : "1000",
    //     apptTimeRangeId : 1,
    //     apptTimeRangeStartTime : "0900",
    //     apptTimeslotId : 1, 
    //     apptType : "VISIT", 
    //     apptTypeId : 4, 
    //     companionIdType : null, 
    //     companionNricFin : null, 
    //     companionPassport : null, 
    //     email : null, 
    //     emailFromUCD : null, 
    //     emailUseUCD : null, 
    //     haveCompanion : false, 
    //     idType : "PASSPORT", 
    //     language : "EN", 
    //     locationDesc : "Tempines Service Centre", 
    //     locationId : 2, 
    //     mid : 1, 
    //     midDesc : "Main Service 1", 
    //     mobileNumber : null, 
    //     mobileNumberFromUCD : "92207844", 
    //     mobileUseUCD : true, 
    //     modeOfContact : "PHONE", 
    //     nricFin : null,
    //     otp : null, otpToken : null, 
    //     passport : hasApptPassport, 
    //     sid : 1, 
    //     sidDesc : "Sub Service 1.1",
    //     hasApptNricFin,
    //     otpToken: "xxx",
    //   }));
    // }
  }, [nric, hasApptNricFin, hasApptPassport]);


  useEffect(() => {
    setTimeout(()=>endComplete(), 1000);

    // appointment-entry page has long content, scroll to top when enter this page
    document.body.scrollTo({ top: 0 });

    return () => {};
  }, []);

  useEffect(()=> {
    
    // get appt info
    // If store don't have appt info, call api to get
    getAppointment(nricFin || passport, otpToken).then(status=>{
      if(status) {
        setInitLoading(false);
      } else {
        // somehow no appt found
        navigate(O2FORM);
      }
    });
  }, [nric, passport]);

  const clkCancelAppt = async () => {
    if(loading) {
      return;
    }
    setLoading(true);
    wogaaStartCancel();
    cancelAppointment(nricFin || passport, otpToken).then(status=>{
      setLoading(false);
      if(status) {
        // don't clear() here. It will cause momentary flash of the form page.
        // dispatch(clear());
        navigate(O2DELETED);
      } else {
        setShowCancelModal(false);
      }
    });
  }

  if(initLoading) {
{/*<>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ fontSize: 20 }}>{nricFin || passport}</div>
            <div>Book an appointment</div>
            <div style={{ fontSize: 20 }}>as at 25 Dec 2022</div>
          </div>
        </>*/}
    return <Layout
      subHeader={"Book an appointment"}
      mainText={
        <div className={"section-header col-md-10 col-sm-10"}>
          <div className="title-container">
            <div className="title__text--overline  fs--default">{isLogin && fullName ? `${fullName}, `: ""}{nricFin || passport}</div>
            <h2 className="title__text title__text--semi-bold">Book an appointment</h2>
          </div>
        </div>
      }>
      <div>
        <div className="form-box--plain mt-3">
          <div className={"px-1 px-3 py-3 py-md-4 text-center"}>
            Loading...
          </div>
        </div>
      </div>
    </Layout>
  }

  const isRescheduleDisabled = moment(apptDateTime).startOf("day").isSameOrBefore(moment().startOf("day"));

// <>
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <div style={{ fontSize: 20 }}>{nricFin || passport}</div>
//             <div>Book an appointment</div>
//             {/*<div style={{ fontSize: 20 }}>as at 25 Dec 2022</div>*/}
//           </div>
//         </>

  return (
    <Layout
      subHeader={"Book an appointment"}
      mainText={
        <div className={"section-header col-md-10 col-sm-10 mb-5"}>
          <div className="title-container">
            <div className="title__text--overline  fs--default">{isLogin && fullName ? `${fullName}, `: ""}{nricFin || passport}</div>
            <h2 className="title__text title__text--semi-bold">Book an appointment</h2>
            <div style={{ fontSize: 20, fontWeight: 400 }}>as at {moment().format("DD MMM YYYY")}</div>
          </div>
        </div>

      }>
      <div>
        <div className="form-box--plain">
          <div className={"px-1 px-3 pt-64 md-pt-48 sm-pt-48"}>
            <h4 className={"text-center sm-mb-32 md-mb-32 lg-mb-48 xl-mb-48 lg-fs-32 xl-fs-32"}>You have a confirmed appointment</h4>
            <TransactionDetail />
            <CustomerDetail />
            <EnquiryDetail />
            <AppointmentDetail />

            {/* <div className="instructions instructions-mod mt-3 non-mobile-hide mobile-mb-2">
              <div className="instructions-content">
                <ul style={{ marginBottom: 0 }}>
                  <li>You can reschedule your appointment up to 1 day in advance.</li>
                  <li>You will receive a reminder 1 day prior to this appointment.</li>
                  <li>
                    As we have to attend to multiple appointments in a day, please be on time for
                    your appointment.
                  </li>
                </ul>
              </div>
            </div> */}

            <div
              className={
                "w-100 d-flex flex-column-reverse flex-md-row  px-md-3 py-2 align-items-start "
              }
              style={{ justifyContent: "center" }}>
              <div className={"mobile-w-100 non-mobile-mx-2"}>
                <CommonButtonSecondary text="Cancel appointment" 
                        onClick={() => { 
                    setShowCancelModal(true); 
                    
                  }}
                />
              </div>
              {!isRescheduleDisabled && 
                <div className={"mb-3 mb-md-0 mobile-w-100 non-mobile-mx-2"}>
                  
                  <CommonButtonSecondary text="Reschedule or edit" 
                    onClick={()=>{
                      navigate(O2APPOINTMENT_ENTRY, { state: { edit: true }});
                    }}
                  />
                </div>
              }
            </div>
            <div className="instructions instructions-mod sm-mt-32 md-mt-32 lg-mt-52 xl-mt-52 sm-mb-28 md-mb-28 lg-mb-24 xl-mb-24">
              <div className="instructions-content">
                <ul style={{ marginBottom: 0 }}>
                  <li>You can reschedule your appointment at least 1 day in advance.</li>
                  <li>If you have booked a phone call appointment, you will receive an SMS on the day of the appointment with a link to call us directly. Our customer service officer will be waiting for your call at the scheduled time.</li>
                  <li>If you have booked a visit to our Service Centre, you will receive a reminder 1 day prior to this appointment. As we have to attend to multiple appointments in a day, please be on time for your appointment.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="form-footer">
            <div
              className={"w-100 d-flex flex-md-row px-md-3 py-2 "}
              style={{ justifyContent: "flex-end" }}>
              <div className={"mb-3 mb-md-0 mobile-w-100"}>
                <CommonButton2 text="Back to contact us" whiteOrFill={"fill"} onClick={()=>{
                  window.location.href = window.contactUsUrl;
                  // navigate(O2FORM)
                }} />
              </div>
            </div>
          </div>
        </div>

        <Modal show={showCancelModal} width={558} >
          <Modal.Header className="dialog-header" closeButton={false} >&nbsp;</Modal.Header>
          <Modal.Body className="sm-p-16 md-p-16 lg-p-24 xl-p-24">
            <div className={"text-center"}>
              <i className={`icon-dls-warning-solid icon-big`} style={{color: "#a46200", fontSize: 80}} aria-hidden="true"></i>
              <p style={{fontWeight: 600, fontSize: 24, lineHeight: "32px"}}>You are about to delete this appointment.</p>
              <p style={{fontWeight: 600, fontSize: 16, lineHeight: "24px"}}>Proceed to delete?</p>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-center flex-md-row flex-column-reverse ">
            <CommonButtonSecondary
              text={"Cancel"}
              onClick={() => setShowCancelModal(false)}
            />
            <CommonButton2
              text={"Proceed"}
              whiteOrFill={"fill"}
              // disabled={loading}
              onClick={() => clkCancelAppt()}
            />
          </Modal.Footer>
        </Modal>
      </div>
    </Layout>
  );
}
